import { useLocation } from 'react-router'

import { useGrowthBook } from '@growthbook/growthbook-react'

import { usePageProps } from '../../../usePageProps'
import { analytics } from '../Configs/analytics'
import type { Category } from '../Configs/categories'
import { enabledPages } from '../Configs/enabledPages'

type ReturnType =
  | { shouldShowGuidedPurchaseJourney: true; journeyType: Category }
  | { shouldShowGuidedPurchaseJourney: false; journeyType: undefined }

export const useShouldShowGuidedPurchaseJourney = (): ReturnType => {
  const location = useLocation()
  const { userAccessState } = usePageProps()

  const growthbook = useGrowthBook()
  const pageData = enabledPages[location.pathname]

  const hasFullAccess =
    userAccessState != null &&
    ['AUTHENTICATED_FULL_ACCESS', 'FULL_ACCESS'].includes(
      userAccessState.transformTypeDecision ?? ''
    )
  if (!pageData || !hasFullAccess) {
    return {
      shouldShowGuidedPurchaseJourney: false,
      journeyType: undefined,
    }
  }
  if (growthbook.isOn(analytics[pageData.journeyType].feature_flag)) {
    return {
      shouldShowGuidedPurchaseJourney: true,
      journeyType: pageData.journeyType,
    }
  } else {
    return {
      shouldShowGuidedPurchaseJourney: false,
      journeyType: undefined,
    }
  }
}
